import moment from 'moment'

import DataExchange from './DataExchange'

import QueryString from '@/utils/QueryString'

export default class PeopleWFFMDataExchange extends DataExchange {
  /**
   * @param {HTMLFormElement} form
   */
  constructor (form) {
    super(form)

    this.peopleSelector = form.querySelector('.custom-select-people')
    this.inputs = this.peopleSelector.querySelectorAll('input[type="text"]')
    this.getCookieData = true
  }

  get data () {
    return {
      adults: this.getAdults(),
      children: this.getChildren(),
      childrenBirthdays: this.getChildrenBirthdays(),
    }
  }

  set data (value) {
    this.getCookieData = false
    this.setAdults(value.adults.value)
    this.setChildren(value.children.value)
    this.setChildrenBirthdays(value.childrenBirthdays)
  }

  get queryComponent () {
    let childrenQuery = this.getChildrenBirthdays().map((birthday, index) => `Child${index + 1}=${birthday.format('YYYYMMDD')}`).join('&')
    if (childrenQuery.length > 0) {
      childrenQuery = `&${childrenQuery}`
    }

    return `Adults=${this.data.adults.value}&Children=${this.data.children.value}${childrenQuery}`
  }

  get cookies () {
    return document.cookie.split(';')
      .filter(el => el.indexOf('child_birthday') !== -1)
      .sort((a1, a2) => a1.localeCompare(a2))
      .map(el => moment(el.split('=')[1], 'DD.MM.YYYY'))
  }

  getAdults () {
    const input = this.inputs[0]
    return {
      value: parseInt(input.value),
      min: parseInt(input.dataset.valRangeMin),
      max: parseInt(input.dataset.valRangeMax),
    }
  }
  
  getChildren () {
    const input = this.inputs[1]
    return {
      value: this.getChildrenCount(parseInt(input.value)),
      min: parseInt(input.dataset.valRangeMin),
      max: parseInt(input.dataset.valRangeMax),
    }
  }

  getChildrenCount (value) {
    const qs = new QueryString()
    if (value == 0 && this.getCookieData && !qs.exists('Children')) {
      return this.cookies.length
    } else {
      return value
    }
  } 

  /**
   * @returns {Array<moment.Moment>} dates of children birthday
   */
  getChildrenBirthdays () {
    const result = []
    const inputs = this.inputs.toArray().splice(2)
    for (let i = 0; i < Math.min(inputs.length, this.getChildren().value); i++) {
      if (i + 1 <= this.cookies.length && !new QueryString().exists(`Child${i + 1}`)) {
        result.push(moment(this.cookies[i], 'DD.MM.YYYY'))
      } else {
        result.push(moment(inputs[i].value, 'DD.MM.YYYY'))
      }
    }
    return result
  }

  setAdults (value) {
    this.inputs[0].value = value
  }

  setChildren (value) {
    this.inputs[1].value = value
  }

  setChildrenBirthdays (value) {
    const inputs = this.inputs.toArray().splice(2)
    for (let i = 0; i < Math.min(inputs.length, this.getChildren().value); i++) {
      if (value[i]) {
        inputs[i].value = moment(value[i]).format('DD.MM.YYYY')
      } else {
        // Fallback if there are no children birthdays in the URL
        inputs[i].value = moment().startOf('day').subtract(3, 'years').format('DD.MM.YYYY')
      }
    }
  }
}

// The following piece of code gets initial values from query string and updates WFFM form
// This is done because WFFM when sending values from main page to listing page does not
// fill them in the form on listing page.
// I suspect this might have something to do with the fact that those are both different
// WFFM forms and that the parameter assignment does not work properly in this case

const form = document.querySelector('form[data-wffm="{8C4CEBFF-9FA5-4C40-AD20-1B8C573DAEF8}"]')

if (form) {
  const data = {
    adults: { value: 2 },
    children: { value: 0 },
    childrenBirthdays: [ '', '', '', '', '', '' ],
  }

  const qs = new QueryString()

  if (qs.exists('Adults')) {
    data.adults.value = qs.get('Adults')
  }

  if (qs.exists('Children')) {
    data.children.value = qs.get('Children')
  }

  for (let i = 1; i <= data.childrenBirthdays.length; i++) {
    if (qs.exists(`Child${i}`)) {
      data.childrenBirthdays[i - 1] = moment(qs.get(`Child${i}`), 'YYYYMMDD')
    }
  }

  new PeopleWFFMDataExchange(form).data = data
}



// WEBPACK FOOTER //
// ./src/services/PeopleWFFMDataExchange.js